import React from 'react'
import styles from "./styles";
import { BotonPrincipal, BotonSecundario } from '../../common/UI/Personalizaciones/Boton'
import ExcelIcono from "../../../assets/iconos/excel-icon.png";
import { connect } from "react-redux";
import UploadFilesService from "../../../services/upload-files";
import * as actions from "../../../actions/grillaPrincipal";
import { withRouter } from "react-router";
import { Container } from '@material-ui/core';

const Botones = (props) => {
    const classes = styles();

    const descargarGrilla = () => {
        const filtro = { ...props.filtro };
        delete filtro.page;
        delete filtro.size;

        UploadFilesService.descargarGrlla(filtro);
    };

    const enviarNuevaPresentacion = () => {
        props.actualizarAtriutoGrilla({
            filtro: null,
            filtroActivo: false,
        });

        props.history.push("/nueva");
    };

  return (
    <Container class="align">
        {!props.fetching && props.presentaciones.length > 0 ? (
            <BotonSecundario
                variant="outlined"
                className={classes.btnExportar}
                onClick={descargarGrilla}
            >
                <img
                    src={ExcelIcono}
                    alt="Icono Excel"
                    className={classes.iconoExcel}
                />
                Exportar Grilla
            </BotonSecundario>
        ) : null}

        {!props.fetching && props.tieneCodigosPrestador && (
            <BotonPrincipal
                variant="contained"
                className={classes.btnNuevaPresentacion}
                onClick={enviarNuevaPresentacion}
            >
                Nueva Presentación
            </BotonPrincipal>
        )}
        
    </Container>
  )
}

const mapStateToProps = (state) => ({
    filtro: state.grillaPrincipalReducer.filtro,
    presentaciones: state.grillaPrincipalReducer.presentaciones,
    fetching: state.grillaPrincipalReducer.fetching,
    tieneCodigosPrestador: state.authReducer.prestadorActivo
        ? state.authReducer.prestadorActivo.codigos.length > 0
        : false,
});

const actionCreators = {
    actualizarAtriutoGrilla: actions.actualizarAtriutoGrilla,
    
};

export default connect(mapStateToProps, actionCreators)(withRouter(Botones));
